import useUTMTracker from './useUTMTracker'

export default () => {
  const context = useUTMTracker()

  return context.state
}
